export default "__VITE_ASSET__f3a8d6b2__"